if (!customElements.get('variant-final-sale')) {
    class FinalSaleText extends HTMLElement {
        constructor() {
            super();
            this.variantSpecs = {};
            this.init();
        }

        init() {
            variantData.forEach(variant => {
                const { id: variantId, finalSale, routeRequired, variantObject, tags } = variant;
                this.variantSpecs[variantId] = {
                    finalSale,
                    routeRequired,
                    tags: tags || (variantObject && variantObject.tags ? variantObject.tags : [])
                };
            });

            this.checkUrlVariant();

            document.addEventListener('on:variant:change', (evt) => {
                this.toggleFinalSaleText(evt.detail?.variant?.id);
            });
        }

        /**
         * Checks the URL for a ?variant= parameter.
         * For multiple variants with no selection it hides the final sale element.
         */
        checkUrlVariant() {
            const finalSaleEl = this.querySelector('.final-sale-text');
            if (!finalSaleEl) return;

            const searchParams = new URLSearchParams(window.location.search);
            const urlVariantId = searchParams.get('variant');

            if (urlVariantId) {
                this.toggleFinalSaleText(urlVariantId);
            } else {
                if (variantData.length > 1) {
                    finalSaleEl.style.display = 'none';
                } else if (variantData.length === 1) {
                    const variantId = variantData[0].id;
                    this.toggleFinalSaleText(variantId);
                }
            }
        }

        /**
         * Shows or hides the final sale text based on the variant’s finalSale flag.
         * If finalSale is true (as a string "true"), it optionally adjusts the text
         * based on product tags (if product data is available globally).
         */
        toggleFinalSaleText(variantId) {
            const finalSaleEl = this.querySelector('.final-sale-text');

            if (!finalSaleEl) return;

            const spec = this.variantSpecs[variantId] || {};
            const isFinalSale = spec.finalSale && spec.finalSale.toLowerCase() === 'true';
            const isRouteRequired = spec.routeRequired && spec.routeRequired.toLowerCase() === 'true';

            if (isFinalSale) {
                let finalText = this.dataset.finalSaleText;

                if (spec.tags && spec.tags.length) {
                    const lowerTags = spec.tags.map(tag => tag.toLowerCase());
                    if (lowerTags.some(tag => tag.includes('category:rugs'))) {
                        finalText = '2X3 Rugs are Final Sale. Return Policy eligible for other sizes.';
                    } else if (lowerTags.some(tag => tag.includes('PLACEHOLDERs'))) {
                        finalText = 'Pillow Covers are Final Sale. Return Policy eligible for pillows that include inserts.';
                    } else if (lowerTags.some(tag => tag === 'category:art')) {
                        finalText = 'Art is Non Returnable.';
                    }
                }

                finalSaleEl.textContent = finalText;
                finalSaleEl.style.display = 'block';
            } else if (isRouteRequired) {
                let finalText = this.dataset.routeRequiredText;
                finalSaleEl.textContent = finalText;
                finalSaleEl.style.display = 'block';
            } else {
                finalSaleEl.style.display = 'none';
            }
        }
    }

    customElements.define('variant-final-sale', FinalSaleText);
}
